module.exports = "/_next/static/images/0cad76dc9a487ce3704b51e9f696346a-word-cup-xs-1x.png.webp";